import { Button, Container, Paper, Typography } from "@mui/material";
// import { useState } from "react";
import { DataGrid } from '@mui/x-data-grid';
import { useEffect, useState } from "react";
import { DialogModal } from "../Components/dialogModal";
import { postAsync } from '../../utils/httpClient';
import { useNavigate } from "react-router-dom";
import { CustomAlretDialog } from "../Components/Dialog";


const AdminInquiry = (props) => {
  const [data, setData] = useState({});
  const [rows, setRows] = useState([]);
  const [dialogMessage, setDialogMessage] = useState('');
  const [dialogOpen, setDialogOpen] = useState(false);
  const [alretDialog, setAlretDialog] = useState(false);
  const [title, setTitle] = useState('');
  const [type, setType] = useState('');

  const navigate = useNavigate();
  const categoryMapping = {
    0: '지점개설문의',
    1: '상점문의',
    2: '라이더문의',
    3: '기타제휴문의',
  };

  const paginationModel = { page: 0, pageSize: 10 };


  // 날짜관련 라이브러리 설치안하고 js 내장 메서드활용
  const formatDate = (isoString) => {
    if (!isoString) return '-';
    const date = new Date(isoString);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // 월은 0부터 시작하므로 +1
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${year}년 ${month}월 ${day}일 ${hours}시 ${minutes}분`;
  };

  useEffect(() => {
    const token = sessionStorage.getItem('gonggam-accessToken');
    if (!token) {
      navigate('/admin/login', { replace: true });
    }
  }, [navigate]);

  const handleDetailClick = (data) => {

    if (data.row.category === '-') {
      setDialogMessage('상세내용이 없습니다');
      setAlretDialog(true);
    }
    else {
      setType(data.row.data.category);
      setData(data.row.data);
      setDialogOpen(true);
      setTitle(data.row.category)

    }
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };
  const handleAlertDialogClose = () => {
    setAlretDialog(false);
  };


  const fetchInquiryList = () => {
    postAsync("/v2/thirdparty/inquiry/list", {
      body: {
        offset: paginationModel.page * paginationModel.pageSize,
        limit: paginationModel.pageSize
      }
    }, sessionStorage.getItem('gonggam-accessToken'))
      .then((res) => {
        const formattedRows = res.data.docs.map((doc, index) => ({
          id: index + 1,
          createdAt: formatDate(doc.createdAt),
          category: categoryMapping[doc.category] || '-',
          user_name: doc.user_name || '-',
          user_phone: `${doc.user_phone || '-'}`,
          region: doc.region || '-',
          contents: doc.contents || '-',
          isView: doc.isView === true ? "Y" : "N",
          memo: doc.memo || '-',
          data: doc,
        }));
        setRows(formattedRows);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };


  useEffect(() => {
    fetchInquiryList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const columns = [
    { field: 'id', headerName: 'No', width: 50, maxWidth: 50, align: 'center' },
    { field: 'createdAt', headerName: '접수일자', minWidth: 250 },
    { field: 'category', headerName: '문의종류', minWidth: 150 },
    { field: 'user_name', headerName: '성함', minWidth: 150 },
    { field: 'user_phone', headerName: '연락처', minWidth: 150 },
    { field: 'region', headerName: '지역', minWidth: 200 },
    { field: 'contents', headerName: '내용', minWidth: 400 },
    // 일단 숨김처리
    { field: 'isView', headerName: '확인여부', minWidth: 50 },
    { field: 'memo', headerName: '메모', minWidth: 200 },
    {
      field: '상세보기',
      headerName: '',
      flex: 1,
      minWidth: 200,
      renderCell: (dataItem) => (
        <Button
          variant="contained"
          color="primary"
          style={{ width: '100%' }}
          onClick={() => handleDetailClick(dataItem)}
        >
          상세보기
        </Button>
      ),
    }
  ];



  return (
    <>
      <Container maxWidth="sm" style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        maxWidth: '100%',
        height: '100vh'
      }}>

        <Typography variant="h4" style={{
          textAlign: 'left',
          width: '100%',
          margin: '50px 0px 30px 0',
          fontWeight: 'bold'
        }}>
          문의하기 - 관리자
        </Typography>

        <Paper sx={{ width: '100%' }}>
          <DataGrid
            rows={rows}
            columns={columns}
            initialState={{ pagination: { paginationModel } }}
            pageSizeOptions={[10, 15]}
            sx={{
              '& .MuiDataGrid-cell': {
                whiteSpace: 'nowrap',
                wordWrap: 'break-word',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                minHeight: '48px',
                alignItems: 'center',
                border: '1px solid rgba(224, 224, 224, 1)',
              },
              '& .MuiDataGrid-columnHeader': {
                borderBottom: '1px solid rgba(224, 224, 224, 1)',
              },
              '& .MuiDataGrid-columnHeader, & .MuiDataGrid-cell': {
                wordBreak: 'break-word',
              },
            }}
          />
        </Paper>

        {dialogOpen && (
          <DialogModal
            title={title}
            dataItem={data}
            open={dialogOpen}
            close={handleDialogClose}
            type={type}
            refreshList={fetchInquiryList}
          />
        )}
        {alretDialog && (
          <CustomAlretDialog
            open={alretDialog}
            message={dialogMessage}
            close={handleAlertDialogClose}
          />
        )}
      </Container>
    </>
  );
}

export default AdminInquiry;
